<div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
    <!-- <h4 class="page-title" *ngIf="breadcrumbs$ | async; let breadcrumbs">{{(breadcrumbs[breadcrumbs.length - 1].label)}}</h4> -->
    <nz-breadcrumb nzSeparator=">" class="py-1">
        <i class="m-r-5 text-primary" nz-icon nzType="home"></i>
        <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs$ | async">
            <a [routerLink]="breadcrumb.url" class="mt-2">
                {{ breadcrumb.label }}
            </a>
        </nz-breadcrumb-item>
    </nz-breadcrumb>
</div>


